

import React, { useState, useEffect } from 'react';

interface ClockProps {
  enabled: boolean;
}

export const Clock: React.FC<ClockProps> = ({ enabled }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    if (!enabled) return;

    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, [enabled]);

  return (
    <div className="flex flex-col items-center justify-center w-1/3 text-stone-600">
      <div className="text-[10px] font-bold opacity-70">
        {currentTime.toLocaleDateString('ja-JP', { month: 'long', day: 'numeric', weekday: 'short' })}
      </div>
      <div className="text-lg font-bold font-mono leading-none tracking-wider">
        {currentTime.toLocaleTimeString('ja-JP', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
      </div>
    </div>
  );
};